import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

// Mass CLR preparer flow (FUZE-612). Nested under Credit Limit Reviews so the breadcrumbs read
// Credit > Credit Limit Reviews > Mass Reviews.
export const Route = createFileRoute('/_auth/_modules/credit/credit-limit-reviews/mass')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/credit-limit-reviews/mass']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
